import * as React from 'react';

function SvgHeart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={40} height={40} viewBox="0 0 25 20" {...props}>
      <path d="M16.4075 18.1834L16.4074 18.1834L16.4039 18.1866C16.3127 18.2686 16.22 18.3521 16.1256 18.437C15.064 19.392 13.789 20.5389 12.1888 22.0885C10.5886 20.5389 9.31354 19.3919 8.25195 18.437C8.15753 18.352 8.06481 18.2686 7.97369 18.1866L7.97314 18.1861C5.65262 16.1008 4.3536 14.9276 2.6169 12.4245L2.61698 12.4244L2.61021 12.415C0.713325 9.76936 1.20518 5.95795 3.69687 3.96124C6.16654 1.98218 9.6623 2.47214 11.539 5.11365L11.569 5.15578L11.5738 5.16091L12.109 6.29763L12.8477 5.20903C14.6546 2.54651 18.1498 1.9853 20.6391 3.91449C23.1394 5.85216 23.7089 9.61046 21.8885 12.3054C21.8524 12.3472 21.8062 12.4068 21.7613 12.4869C20.0128 14.9646 18.7392 16.1108 16.4075 18.1834Z" />
    </svg>
  );
}

export default SvgHeart;
